import { Upload } from "@aws-sdk/lib-storage";
import { S3Client } from "@aws-sdk/client-s3";
import handleApi from "./api";
import store from "../store/index";

let db;

const credentials = {
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_AWS_SECRET_ACCESS_KEY,
};

const makeTX = (storeName, mode) => {
  let tx = db.transaction(storeName, mode);
  tx.onerror = (err) => {
    console.warn(err);
  };
  return tx;
};

export const createIndexedDB = () => {
  let objectStore = null;
  let DBOpenReq = indexedDB.open("ico-test-db3", 1);
  // console.log("creating.... React");
  DBOpenReq.addEventListener("error", (err) => {
    // console.log("error", err);
  });

  DBOpenReq.addEventListener("success", (e) => {
    db = e.target.result;
    // console.log("success", db);
  });
  DBOpenReq.addEventListener("upgradeneeded", (e) => {
    db = e.target.result;
    // console.log("Upgrade", db);
    if (!db.objectStoreNames.contains("ico")) {
      // console.log("Creating store");
      objectStore = db.createObjectStore("ico", {
        keyPath: "id",
      });
    }
  });
};

var uploadVideoToIndexedDB = (id, blob, type, tag, cid) => {
  let tx = makeTX("ico", "readwrite");
  tx.oncomplete = (e) => {
    // console.log(e);
  };
  let store = tx.objectStore("ico");
  let request = store.add({
    id,
    blob,
    type,
    tag,
    cid,
  });
  request.onsuccess = (e) => {
    // console.log("Successfully Uploaded to db", e);
    // console.log("Close window initiated");
  };
  request.onerror = (err) => {
    // console.log("error", err);
  };
};

export const uploadBlobsToS3 = async (
  recordedChunkBlob,
  folderName,
  call_id,
  type,
  format = "webm",
  leaveMessage = false
) => {
  try {
    const audioBlob = recordedChunkBlob;
    const timestamp = new Date().getTime();

    if (false && "serviceWorker" in navigator && "SyncManager" in window) {
      uploadVideoToIndexedDB(
        timestamp,
        audioBlob,
        "audio/webm",
        "final_audio",
        call_id
      );
      return;
    }

    const audioFileName = `${timestamp}.${format}`;
    const key = `${call_id}/${folderName}/${audioFileName}`;
    const contentType = `${type}/${format}`;

    // Get presigned URL from backend
    const accessToken = store.getState().room.accessToken;
    const response = await handleApi("/s3/get-upload-url", "POST", {
      key,
      contentType,
      accessToken,
      leaveMessage,
    });

    if (!response.success) {
      throw new Error("Failed to get upload URL");
    }

    const { signedUrl } = response.data;

    // Upload file using presigned URL
    const uploadResponse = await fetch(signedUrl, {
      method: "PUT",
      body: audioBlob,
      headers: {
        "Content-Type": contentType,
      },
    });

    if (!uploadResponse.ok) {
      throw new Error("Failed to upload file");
    }

    // Public URL for preview & save: backend may send it, else build from base URL + key
    const locationFromBackend =
      response.data.Location ?? response.data.location;
    const baseUrl = process.env.REACT_APP_RECORDINGS_PUBLIC_BASE_URL?.replace(
      /\/$/,
      ""
    );
    const Location =
      locationFromBackend ||
      (baseUrl ? `${baseUrl}/${key}` : null);

    return {
      key,
      bucket: "iconnect-final-recordings", // This is just for compatibility with previous response
      ...(Location && { Location }),
    };
  } catch (error) {
    // console.error("Error uploading file:", error);
    throw error;
  }
};
